import { SESSION_TERMINATED, USER_EXPIRED } from "redux-oidc";
import { IAction } from '../../commonInterfaces/IAction';
import { actionTypes } from "../../constants/actionTypes";
import { nodeType } from "../../constants/NodeTypes";
import GeneratorEntity from '../../models/Generator';
import Node from "../../models/Node";




export interface IGeneratorState {
  editingGenerator: GeneratorEntity
  generators: GeneratorEntity[]
  activeNode: Node
  searchFilter: string
}

const initialState = {
  activeNode: new Node(),
  editingGenerator: new GeneratorEntity(),
  generators: [],
  searchFilter: ""
};

export default function reducer(state: IGeneratorState = initialState, action: IAction) {
  switch (action.type) {
    case SESSION_TERMINATED:
    case USER_EXPIRED:
      return Object.assign({}, state, { generators: [] });
    case actionTypes.LOAD_GENERATORS_SUCCESS:
      return {
        ...state,
        activeNode: {
          ...state.activeNode,
          children: action.payload,
          displayName: "Generators",
          nodeType: nodeType.folder,
          propertyName: ""
        },
        generators: action.payload,

      }
    // return Object.assign({}, state, { generators: action.payload })
    case actionTypes.GENERATOR_FILTER_UPDATE:
      return {
        ...state,
        searchFilter: action.payload
      }

    case actionTypes.LOAD_REMAINING_GENERATOR_DETAIL_SUCCESS:
      const newGen: GeneratorEntity = action.payload;
      const newGens: GeneratorEntity[] = [...state.generators]
      for (const gen in newGens) {
        if(newGens[gen].id === newGen.id) {
          newGens[gen] = newGen;
          newGens[gen].hasAllData = true;
        }
      }
      return {
        ...state,
        generators: newGens

      }
    case actionTypes.REFRESH_ACTIVE_NODE:

      const newNode: Node = { ... state.activeNode}
      switch (state.activeNode.nodeType) {
        case nodeType.folder:
          if (state.activeNode.propertyName === "" || state.activeNode.propertyName === "/") {
            newNode.displayName = "Home"
            newNode.children = state.generators
          } else {
            const children: GeneratorEntity[] = []
            state.generators.forEach((gen: GeneratorEntity) => {
              const searchPath = newNode.propertyName.substr(1)
              if ((gen.path + "/").startsWith(searchPath)) {
                children.push(gen)
              }
            });
            newNode.children = children
          }
          break;
        case nodeType.category:
          if  (state.activeNode.propertyName === "" || state.activeNode.propertyName === "/") {
            newNode.displayName = "Home"
            newNode.children = state.generators
          } else {
            const children: GeneratorEntity[] = []
            state.generators.forEach((gen: GeneratorEntity) => {
              if (gen.categories !== null){
              gen.categories.forEach((cat: string) => {
                if (cat === newNode.propertyName) {
                  if (children.indexOf(gen) === -1) {
                    children.push(gen)
                  }
                }
              })}
            })
            newNode.children = children
          }
        default:
          break;
      }
      return {
        ...state,
        activeNode: newNode
      }
    case actionTypes.UPDATE_ACTIVE_NODE:
      const name: string = action.payload.propertyName;
      const display: string = action.payload.displayName;
      const type: string = action.payload.nodeType;
      return {
        ...state,
        activeNode: {
          ...state.activeNode,
          displayName: display,
          nodeType: type,
          propertyName: name,
        }
      }
    case actionTypes.VALIDATION_SUCCESS:
      return {
        ...state
      }

    case actionTypes.DELETE_GENERATOR_START:
      const toDelete: GeneratorEntity = action.payload
      const genCopy = []
      for (const key in state.generators) {
        if(state.generators[key].id !== toDelete.id ) {
          genCopy.push(state.generators[key])
        }
      }
      return {
        ...state,
        generators: genCopy
      }

    default:
        return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducer/generators.ts